export default "<div class=\"subsection_action\">\n  <!-- <span>View All</span> -->\n  <ng-content></ng-content>\n</div>\n";